/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { UserJoinLoyaltyCreateStatus200, UserJoinLoyaltyCreateStatus401, UserJoinLoyaltyCreateStatus503 } from "../types/UserJoinLoyaltyCreate.ts";
import type { MutationObserverOptions, QueryClient } from "@tanstack/vue-query";
import { userJoinLoyaltyCreate } from "../requests/userJoinLoyaltyCreate.ts";
import { useMutation } from "@tanstack/vue-query";

export const userJoinLoyaltyCreateMutationKey = () => [{ url: "/api/user/join-loyalty/" }] as const;

/**
 * @description Присоединение к программе лояльности.
 * @summary присоединение к лояльности
 * {@link /api/user/join-loyalty/}
 */
export function useUserJoinLoyaltyCreate<TContext>(
	options: {
		mutation?: MutationObserverOptions<
			UserJoinLoyaltyCreateStatus200,
			ResponseErrorConfig<UserJoinLoyaltyCreateStatus401 | UserJoinLoyaltyCreateStatus503>,
			undefined,
			TContext
		> & { client?: QueryClient };
		client?: Partial<RequestConfig> & { client?: Client };
	} = {},
) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions?.mutationKey ?? userJoinLoyaltyCreateMutationKey();

	return useMutation<UserJoinLoyaltyCreateStatus200, ResponseErrorConfig<UserJoinLoyaltyCreateStatus401 | UserJoinLoyaltyCreateStatus503>, undefined, TContext>(
		{
			mutationFn: async () => {
				return userJoinLoyaltyCreate(config);
			},
			mutationKey,
			...mutationOptions,
		},
		queryClient,
	);
}
